var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"nav"}},[_c('HeaderView'),_c('SidebarView',{ref:"sidebarView"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }